import styles from './styles.module.scss';
import buttons from '@/styles/button.module.scss';
import typography from '@/styles/typography.module.scss';
import classNames from 'classnames';
import React, { ReactNode } from 'react';

export function FormSendingResult({
  icon,
  title,
  subtitle,
  cta,
  onClose,
}: {
  icon: ReactNode;
  title: ReactNode;
  subtitle: ReactNode;
  cta: ReactNode;
  onClose: () => void;
}) {
  return (
    <div className={styles.formSendingResult}>
      {icon}
      <div>
        <div className={typography.h4}>{title}</div>
        <div className={typography.subheadingSM}>{subtitle}</div>
      </div>
      <button className={classNames(buttons.btn, buttons.btnPrimary, buttons.btnM)} onClick={onClose}>
        {cta}
      </button>
    </div>
  );
}
